<div class="toaster-component">
  <div *ngIf="isSuccess" class="alert alert-success">
    <strong>{{message}}</strong>
  </div>
  <div *ngIf="isError" class="alert alert-danger">
    <strong>{{message}}</strong>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/_screens/_shared/toaster/toaster.component.html